import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Profile } from '../models/profile';

export const AuthActions = createActionGroup({
  source: 'Auth',
  events: {
    Init: emptyProps(),
    'Init Success': props<{
      userId: string | null;
      passwordRecovery: boolean;
      profile: Profile | null;
    }>(),
    'Session Changed': props<{
      userId: string | null;
      passwordRecovery: boolean;
      event: string;
    }>(),
    'Profile Loaded': props<{ profile: Profile | null }>(),
    'Load Profile': emptyProps(),

    'Sign In With Email': props<{ email: string; password: string }>(),
    'Sign In With Google': emptyProps(),
    'Sign In Failed': props<{ error: string }>(),
    'Sign Up': props<{ email: string; password: string }>(),
    'Sign Up Success': props<{ email: string }>(),
    'Sign Up Failed': props<{ error: string }>(),
    'Reset Password': props<{ email: string }>(),
    'Reset Password Success': props<{ email: string }>(),
    'Reset Password Failed': props<{ error: string }>(),
    'Update Password': props<{ password: string }>(),
    'Update Password Success': emptyProps(),
    'Update Password Failed': props<{ error: string }>(),
    'Set Username': props<{ username: string }>(),
    'Set Username Success': props<{ profile: Profile }>(),
    'Set Username Failed': props<{ error: string }>(),
    'Sign Out': emptyProps(),
    'Sign Out Success': emptyProps(),
    'Exchange Code': props<{ code: string }>(),
    'Exchange Code Failed': props<{ error: string }>(),
    'Auth Flow Success': emptyProps(),
  },
});
